import { IntegrationSavedSuccessWebView } from '../view/IntegrationSavedSuccessWebView';
import { templateIntegrationSuccess } from '../view/template';
import { BaseWebComponentController } from '../../../framework/BaseWebComponentController';
import { IntegrationSavedSuccessWebComponent } from '../component/IntegrationSavedSuccessWebComponent';
import { IntegrationType, SENSORS_BY_INTEGRATION_MAP } from '../../types/integration-type';
import { SensorEnabledStatus } from '../../common/types';
import { ADOnPremSensorView } from '../../sensors/ad-onprem/view/ADOnPremSensorView';
import { SensorType } from '../../sensors/types/sensor-type';

export class IntegrationSavedSuccessWebController extends BaseWebComponentController {
  public component: IntegrationSavedSuccessWebComponent;
  public view: IntegrationSavedSuccessWebView;
  public viewConstructor: typeof IntegrationSavedSuccessWebView;

  constructor(component: IntegrationSavedSuccessWebComponent) {
    super(component);
    this.initialSetup({
      viewConstructor: IntegrationSavedSuccessWebView,
      viewTemplate: templateIntegrationSuccess,
    });
  }

  public updateBasedOnSensors(integrationName: string, integrationType: IntegrationType, sensors: Object[]) {
    if (!this.view.isConnected) {
      return;
    }
    const translations = this.view.getTranslations();

    if (this.dependencies.isPartnerCompany()) {
      this.view.dom.$successDescription.innerHTML = this.dependencies.translateFn(
        "You've added {integrationName} ( {integrationType} ) {break} to your sensor list for {companyName}",
        {
          integrationName: `<b>${integrationName}</b>`,
          integrationType: this.translator.getTranslatedIntegrationNameByType(integrationType),
          break: '<br>',
          companyName: `<b>${this.dependencies.getActiveCompany().companyName}</b>`,
        }
      );
    } else {
      this.view.dom.$successDescription.innerHTML = this.dependencies.translateFn(
        'You added {integrationName} ( {integrationType} ) to the sensor list.',
        {
          integrationName: `<b>${integrationName}</b>`,
          integrationType: this.translator.getTranslatedIntegrationNameByType(integrationType),
        }
      );
    }

    this.view.dom.$includedSensors.innerHTML = '';
    this.view.dom.$includedSensorsTitle.innerText = '';
    const sensorsAdded: SensorType[] = [];
    if (SENSORS_BY_INTEGRATION_MAP[integrationType].length > 1) {
      this.view.dom.$includedSensorsTitle.innerText = this.dependencies.translateFn('Included sensors:');
      sensors.forEach(sensor => {
        if (sensor['enabledStatus'] === SensorEnabledStatus.ENABLED && !sensorsAdded.includes(sensor['type'])) {
          sensorsAdded.push(sensor['type']);
          const el = document.createElement('li');
          el.innerText = translations.sensorNames[sensor['type']];
          this.view.dom.$includedSensors.appendChild(el);
        }
      });
    }

    if (integrationType === IntegrationType.AD_ONPREM) {
      this.view.dom.$extraInfo.style.visibility = 'visible';
      this.view.dom.$extraInfo.innerHTML = ADOnPremSensorView.getExtraInfoText(this.dependencies);
    } else {
      this.view.dom.$extraInfo.style.visibility = 'hidden';
    }
  }
}
